// extracted by mini-css-extract-plugin
export default {"form":"CriarConta_form__M6KuY","alerta":"CriarConta_alerta__djlUO","link":"CriarConta_link__1sIpz","termos":"CriarConta_termos__Bt+Lo","trocaFluxo":"CriarConta_trocaFluxo__KfaTb"};